<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Modulo de Usuario - Nuevo</strong>
          </CCardHeader>
          <CCardBody>
            <b-form  @submit.prevent="Validate">
              <b-row>

                <b-col md="3">
                  <b-form-group>
                      <b-card-img style="max-height: 200px" :src="previewImage"></b-card-img>
                  </b-form-group>
                  <b-form-group>
                    <b-form-file accept="image/png, image/jpeg" @input="pickFile" ref="fileInput" @change="onLogoChange" v-model="image" placeholder="Seleccione un foto..." drop-placeholder="Suelta la imagen aquí..."></b-form-file>
                  </b-form-group>
                  <b-form-group label="Tipo Impresión:">
                    <b-form-select v-model="user.type_print" :options="type_print"></b-form-select>
                  </b-form-group>
                  <b-form-group label="Fondo:">
                    <b-form-input type="color"  v-model="user.background"></b-form-input>
                  </b-form-group>
                </b-col>


                <b-col md="6">
                  <b-row>
                    <b-col md="12">
                      <b-form-group label="Tipo de Usuario :" required>
                        <select ref="id_user_type" class="form-control" v-model="user.id_user_type">
                          <option value="">-- Seleccione --</option>
                          <option v-for="item of user_type" :key="item.id_user_type" :value="item.id_user_type">
                            {{ item.name }}
                          </option>
                        </select>
                        <small  v-if="errors.id_user_type" class="form-text text-danger">Seleccione un tipo de usuario</small>
                      </b-form-group>
                    </b-col>
                
                    <b-col md="12">
                      <b-form-group label="Nombres :" required>
                        <b-form-input type="text" ref="name" v-model="user.name" placeholder="Ingrese su nombre"></b-form-input>
                        <small v-if="errors.name" class="form-text text-danger" >Ingrese un nombre de usuario</small>
                      </b-form-group>
                    </b-col>

                
             
                    <b-col md="6">
                      <b-form-group label="Usuario :" required>
                        <b-form-input type="text" ref="user" v-model="user.user" placeholder="Ingrese su nombre de usuario"></b-form-input>
                        <small v-if="errors.user" class="form-text text-danger">Ingrese un usuario</small>
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <b-form-group label="Telefono :" required>
                        <b-form-input type="text" ref="phone" v-model="user.phone" placeholder="Ingrese su Telefono"></b-form-input>
                      </b-form-group>
                    </b-col>
           
                    <b-col md="12">
                      <b-form-group label="Email :" required>
                        <b-form-input type="email" ref="email" v-model="user.email" placeholder="Ingrese su email" ></b-form-input>
                        <small v-if="errors.email" class="form-text text-danger">Ingrese un email de usuario</small>
                      </b-form-group>
                    </b-col>
              
                    <b-col md="12">
                      <b-form-group label="Password :" label-for="input-1">
                        <b-form-input
                          type="password"
                          ref="password"
                          v-model="user.password"
                        ></b-form-input>
                        <small class="form-text text-info"
                          >Ingrese un password solo en caso de resetar una
                          contraseña</small
                        >
                      </b-form-group>
                    </b-col>
                    <b-col md="12">
                      <b-form-group label="Estado :" label-for="input-1">
                        <select  ref="state"  v-model="user.state" class="form-control">
                          <option value="1">Activo</option>
                          <option value="0">Inactivo</option>
                        </select>
                      </b-form-group>
                    </b-col>
                 
                  </b-row>

                </b-col>

                

                <b-col md="12"></b-col>
             

                <b-col md="3"></b-col>
                <b-col md="6">
                  <b-button type="submit" class="form-control btn-primary"><i class="fas fa-save"></i> Guardar (F4)</b-button>
                </b-col>
              </b-row>
            </b-form>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";

export default {
  name: "UsuarioAdd",
  data() {
    return {
      module:'User',
      role:2,
      user: {
        id_user: "",
        id_user_type: "",
        name: "",
        last_name: "",
        user: "",
        email: "",
        password: "",
        phone: "",
        state: 1,
        image: '',
        background:'',
        type_print:'Ticket',
        image_change:'',
      },
      previewImage:'https://www.sinrumbofijo.com/wp-content/uploads/2016/05/default-placeholder.png',
      image: null,
      user_type: [],
      type_print:[
        {value:'Ticket', text:'Ticket'},
        {value:'PDF', text:'PDF'},
      ],
      //errors
      errors: {
        id_user_type: false,
        name: false,
        last_name: false,
        user: false,
        email: false,
        password: false,
      },
      validate: false,
    };
  },
  mounted() {
    this.ListUserType();
  },
  methods: {
    onLogoChange,
    ListUserType,
    AddUser,
    Validate,
    pickFile () {
      let input = this.$refs.fileInput
      let file = input.files
      if (file && file[0]) {
        let reader = new FileReader
        reader.onload = e => {
          this.previewImage = e.target.result
        }
        reader.readAsDataURL(file[0])
        this.$emit('input', file[0])
      }
    }
  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
  },
};
function onLogoChange(e) {
  this.user.image = e.target.files[0];
}

function ListUserType() {
  let me = this;
  let url = this.url_base + "usertype-list-active";

  axios({
    method: "GET",
    url: url,
    headers: {
      token: this.token,
    },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.user_type = response.data.result;
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
    })
}

function AddUser() {
 
  let me = this;
  let url = me.url_base + "user/add";
  let data = new FormData();

  data.append("id_user", me.user.id_user);
  data.append("id_user_type", me.user.id_user_type);
  data.append("name", me.user.name);
  data.append("last_name", me.user.last_name);
  data.append("user", me.user.user);
  data.append("email", me.user.email);
  data.append("password", me.user.password);
  data.append("phone", me.user.phone);
  data.append("state", me.user.state);
  data.append("background", me.user.background);
  data.append("image", me.user.image);
  data.append("type_print", me.user.type_print);

  axios({
    method: "POST",
    url: url,
    data: data,
    headers: {
      "Content-Type": "application/json",
      token: me.token,
      module: me.module,
      role: me.role,
    },
  })
    .then(function (response) {
      if (response.data.status == 201) {
        me.user.id_user_type = "";
        me.user.name = "";
        me.user.last_name = "";
        me.user.phone = "";
        me.user.user = "";
        me.user.email = "";
        me.user.password = "";
        me.user.state = 1;
        me.user.image = '';
        me.user.type_print = 'Ticket';
        me.user.background = '';
        me.image = null,
        Swal.fire({ icon: 'success', text: 'Se ha creado el nuevo usuario', timer: 3000,})
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
    })
}

function Validate() {
  this.errors.id_user_type = this.user.id_user_type.length == 0 ? true : false;
  this.errors.name = this.user.name.length == 0 ? true : false;
  this.errors.user = this.user.user.length == 0 ? true : false;
  this.errors.email = this.user.email.length == 0 ? true : false;
  this.errors.password = this.user.password.length == 0 ? true : false;

  if (this.errors.id_user_type) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate = false; }
  if (this.errors.name) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate = false; }
  if (this.errors.user) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate = false; }
  if (this.errors.email) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate = false; }
  if (this.errors.password) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate = false; }


  let me = this;

  if (!this.validate) {
    Swal.fire({
      title: "Esta seguro de registrar el usuario?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Estoy de acuerdo!",
    }).then((result) => {
      if (result.value) {
        this.AddUser();
      }
    });

  }

}
</script>
